import axios from 'axios';

const axsiosInstans = axios.create({
	withCredentials: true,
	baseURL: 'https://redwi-v-back-for-portfolio-4838.twc1.net/',
	headers: {
		Authorization: `Bearer ${sessionStorage.getItem('token') || null}`,
	},
});

export default axsiosInstans;
